<template>
	<div class="page">
		<div class="pageTitleBox" style="align-items: center;">
			<div class="boxNameL">
				编辑疫苗套餐
			</div>
			<el-button type="warning" @click="isBack" size="small">返回</el-button>
			<!-- <div class="boxNameR">
				<el-button type="warning" @click="isBack" size="small">返回</el-button>
			</div> -->
		</div>
		<div class="wrap">
			<el-form ref="form" style="padding-bottom: 80px;" :model="editParams" label-width="100px" :rules='rules'>
				<div class="tit">
					<span class="name">基础设置</span>
				</div>
				<el-form-item label="分类">
					<el-cascader size="mini" filterable ref="cascader" clearable v-model="productTypeIds" :options="categoryData[0].children"
					:show-all-levels="true" :props="{ label: 'label',value:'id' }" @change="changeCategory"></el-cascader>
				</el-form-item>
				<el-form-item label="套餐名称" prop="title">
					<el-input v-model="editParams.title" size="mini" style="width: 200px;" placeholder="请输入商品描述"></el-input>
				</el-form-item>
				<el-form-item label="适用品种" prop="applyType">
					<el-radio-group v-model="editParams.applyType">
						<el-radio label="0">通用</el-radio>
						<el-radio label="1">猫用</el-radio>
						<el-radio label="2">犬用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否复购">
					<el-radio-group v-model="editParams.buy_back">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="线上线下">
					<el-radio-group v-model="editParams.group_type">
						<el-radio label="1">线上</el-radio>
						<el-radio label="0">线下</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否参与提成" >
					<el-radio-group v-model="editParams.join_commission">
						<el-radio :label="Number('0')">否</el-radio>
						<el-radio :label="Number('1')">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<storeSelect v-if='showShops' title='应用门店' :storeIds='storeIds' @sendStore='getStores'></storeSelect>
				<div class="tit">
					<span class="name">设置服务项</span>
				</div>
				<el-form-item label="项目类型" >
					<el-radio-group v-model="editParams.buyWay">
						<el-radio label="0">买赠</el-radio>
						<el-radio label="1">折扣</el-radio>
						<el-radio label="2">自定义</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="设置折扣率" v-if="editParams.buyWay=='1'" >
					<el-input-number size="mini" v-model="editParams.discount_rate" :min="0" :max="1" label="描述文字"></el-input-number>
					<span style="margin-left: 5px;color: #e6a23c;">折扣率请输入0-1之间的数字</span>
				</el-form-item>
				<el-form-item label="自定义价格" v-if="editParams.buyWay=='2'" >
					<el-input   size="mini" style="width: 120px;" v-model="editParams.min_price " placeholder="请输入最小价格"></el-input>
					-
					<el-input  size="mini" style="width: 120px;" v-model="editParams.max_price" placeholder="请输入最大价格"></el-input>
				</el-form-item>
				<el-form-item label="结算后订单是否可更换"  label-width="180px">
					<el-radio-group v-model="editParams.checkout_replace.support_replace">
						<el-radio :label="Number(0)">否</el-radio>
						<el-radio :label="Number(1)">是</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="结算订单后更换折扣率" v-if="editParams.checkout_replace.support_replace==1" 
				label-width="180px">
					<el-input-number size="mini" v-model="editParams.checkout_replace.replace_discount_rate" :min="0" :max="1" label="描述文字"></el-input-number>
					<span style="margin-left: 5px;color: #e6a23c;">折扣率请输入0-1之间的数字</span>
				</el-form-item>
				<div style="padding: 0 50px;">
					<el-table :data="[editParams.vaccine_plan]" default-expand-all row-class-name="row-expand-cove">
						<el-table-column prop="plan_name" label="计划名称">
							<template slot-scope="scope">
								<el-input v-model="scope.row.plan_name" size="mini" style="width: 200px;" placeholder="请输入计划名称"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<span v-if="scope.row.must_use==0">否</span>
								<span v-else>是</span>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.next_plan_days"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="针数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">疫苗针数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.use_count"
								placeholder="请输入针数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.use_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column prop="sku_name" label="规格">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>
											
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.use_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">

							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-plus" type='warning' @click="dialogAddShop_state = true; planCurrentrow = scope.row;tree=[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e89c904d9db7ccf3bf6'}]}]">添加物品</el-button>
								
							</template>
						</el-table-column>
					</el-table>
					<el-table :data="[editParams.rabies_vaccine_plan]" default-expand-all row-class-name="row-expand-cove">
						<el-table-column prop="plan_name" label="计划名称">
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<span v-if="scope.row.must_use==0">否</span>
								<span v-else>是</span>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.next_plan_days"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.use_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column prop="sku_name" label="规格">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>
											
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.use_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
					
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-plus" type='warning' @click="dialogAddShop_state = true; planCurrentrow = scope.row;tree=[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e89c904d9db7ccf3bf6'}]}]">添加物品</el-button>
								
							</template>
						</el-table-column>
					</el-table>

					<!-- v-if="editParams.buyWay==0" -->
					<el-table  :data="[editParams.additional_medical_service_plan]" default-expand-all row-class-name="row-expand-cove">

						<el-table-column prop="plan_name" label="计划名称">
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<el-select v-model="scope.row.must_use" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="是否收费">
							<template slot-scope="scope">
								<el-select v-model="scope.row.charge_status" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.next_plan_days"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.use_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column prop="sku_name" label="规格">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>
											
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.use_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
							
							<template slot-scope="scope">
								<el-button size="mini" icon="el-icon-plus" type='warning' @click="dialogAddShop_state = true; 
								planCurrentrow = scope.row;
								tree=[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e88c904d9db7ccf3bf2'}]},{id:'601d11cfa93f55b5cf3ae2eb',children:[{id:'601d11d0a93f55b5cf3ae2fa'}]}]">添加物品</el-button>
								
							</template>
						</el-table-column>
					</el-table>

					<!-- v-if="editParams.buyWay==0" -->
					<el-table  :data="[editParams.additional_enhance_needle]" default-expand-all row-class-name="row-expand-cove">

						<el-table-column prop="plan_name" label="计划名称">
						</el-table-column>
						<el-table-column prop="name" label="是否必开项">
							<template slot-scope="scope">
								<el-select v-model="scope.row.must_use" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
								
							</template>
						</el-table-column>
						<el-table-column prop="name" label="是否收费">
							<template slot-scope="scope">
								<el-select v-model="scope.row.charge_status" placeholder="请选择">
									<el-option label="是" :value="1"></el-option>
									<el-option label="否" :value="0">否</el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column label="间隔天数">
							<template slot='header'>
								<span style="color: #FF0000;">*</span>
								<span class="m-l-10">间隔天数</span>
							</template>
							<template slot-scope="scope">
								<el-input style="width: 200px;" type='number' size='small' v-model.number="scope.row.use_count"
								placeholder="请输入间隔天数"></el-input>
							</template>
						</el-table-column>
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-table :data="props.row.use_items" show-summary style="width: 100%">
									<el-table-column prop="goods_name" label="商品名称">
									</el-table-column>
									<el-table-column prop="brand_name" label="品牌">
									</el-table-column>
									<el-table-column prop="sku_name" label="规格">
									</el-table-column>
									<el-table-column label="数量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.use_num" placeholder="请输入物品数量"></el-input>
											
										</template>
									</el-table-column>
									<el-table-column label="出库量" >
										<template slot-scope="scope">
											<el-input type='number' style="width: 80px;" size='small' v-model.number="scope.row.out_num" placeholder="出库量"></el-input>
										
										</template>
									</el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-delete" type='danger' @click="props.row.use_items.splice(scope.$index,1)"></el-button>
										</template>
									</el-table-column>
								</el-table>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180px">
							<template slot-scope="scope">
								
								<el-button size="mini" icon="el-icon-plus" type='warning' @click="dialogAddShop_state = true; planCurrentrow = scope.row;
								tree=[{id:'602f1e88c904d9db7ccf3bec',children:[{id:'602f1e89c904d9db7ccf3bf6'},{id:'602f1e88c904d9db7ccf3bed',children:[{id:'602f1e88c904d9db7ccf3bf1'}]}]}]">添加物品</el-button>							
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
		</div>
		<div v-if="dialogAddShop_state">
			<dialogNewGoods @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" :tree="tree"
			@submit='getgoods'></dialogNewGoods>
		</div>
		<div class="footer">
			<div style="margin: auto;">
				<el-button type="primary" size="small" :loading="loading" @click='submit'>确定</el-button>

			</div>
		</div>
	</div>
</template>

<script>
	import {
		setVaccineGroup,
		getVaccineGroupDl,
		getProductTypeList,
		getProductTypeDl,
	} from '../../../api/productApi.js'
	import dialogNewGoods from "../../../components/dialog_addShop.vue"
	import storeSelect from "../../../components/storeSelect.vue"
	export default {
		components: {
			storeSelect,
			dialogNewGoods
		},
		data() {
			return {
				dialogAddShop_state: false,
				planCurrentrow: '',
				tree:[],
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				categoryData: [],
				productTypeIds: [],
				editParams: {
					groupId: '',
					title: '',
					category_info: {
						_id: '',
						name: '',
						code: '',
					},
					buy_back:1,
					group_type:'0',
					category_list: [],
					applyType: '0',
					buyWay: '0',
					checkout_replace: {
						support_replace: 0,
						replace_discount_rate: 0,
					},
					discount_rate: 0,
					min_price:0,
					max_price:0,
					vaccine_plan: {
						plan_name: '疫苗',
						use_count: 2,
						next_plan_days: 1,
						must_use: 1,
						use_items: [],
					},
					rabies_vaccine_plan: {
						plan_name: '狂犬疫苗',
						use_count: 1,
						next_plan_days: 1,
						use_items: [],
						must_use: 1,
					},
					additional_medical_service_plan: {
						plan_name: '检测服务',
						use_count: 1,
						next_plan_days: 1,
						use_items: [],
						must_use: 1,
						charge_status: 0,
						charge_discount: 0,
					},
					additional_enhance_needle: {
						plan_name: '附加项',
						use_count: 1,
						next_plan_days: 1,
						use_items: [],
						must_use: 1,
						charge_status: 0,
						charge_discount: 0,
					},
					join_commission: 1,
					shop_info:[],
				},
				loading: false,
				storeIds: [],
				showShops: true,
			}
		},
		methods: {
			isBack() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/group/group',
						query:{type:2}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						setVaccineGroup(this.editParams).then(res=>{
							if(res.code==0){
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.$router.push({
									path: '/group/group',
									query:{type:2}
								})
							}
						})
					} else {

						return false;
					}
				});
			},
			getStores(data) {
				this.editParams.shop_info = data;
			},
			getgoods(data) {
				console.log(data, '111')
				// console.log(this.planCurrentrow);
				this.planCurrentrow.use_items.push({
					goods_type: data.goodsType,
					goods_id:data.goodsType==4?data.goodsItem.serviceId:data.goodsItem.medical_id,
					use_num: 1,
					out_num: 1,
					sku_id:data.goodsType==4?data.skuItem.service_objectId:'',
					sku_name:data.goodsType==4?data.skuItem.service_objectName:data.goodsItem.old_packinfo_info.sku_value,
					goods_name: data.goodsItem.title,
					brand_name: data.goodsItem.brand_name,
				})
			},
			getVaccineGroupDl(id){
				this.showShops = false;
				getVaccineGroupDl({id}).then(res=>{
					if(res.code==0){
						this.editParams = res.data;
						this.productTypeIds =[];
						this.productTypeIds.push(res.data.category_info._id);
						this.storeIds = this.editParams.shop_info.map(item => {
							return item.shop_id
						})
						this.showShops = true;
					}
				})
			},
			getProductTypeList() {
				getProductTypeList({
					category: '套餐'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data[0].children;
			
					}
				})
			},
			changeCategory(val) {
				if (val.length > 0) {
					getProductTypeDl({
						id: val[val.length - 1]
					}).then(res => {
						if (res.code == 0) {
							this.editParams.category_info._id = res.data._id;
							this.editParams.category_info.name = res.data.name;
							this.editParams.category_info.code = res.data.code;
							this.editParams.category_list = res.data.parent_all;
						}
					})
				}
			},
		},
		created() {
			this.getProductTypeList();
			if (this.$route.query.id) {
				this.getVaccineGroupDl(this.$route.query.id)
			} else {
				this.storeIds = this.$store.state.userInfo.shops.map(item => {
					return item.shop_id
				})
				this.editParams.shop_info = this.$store.state.userInfo.shops
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		.wrap{
			background-color: #fff;
			padding-bottom: 20px;
		}
		.tit {
			font-size: 16px;
			margin-bottom: 28px;
			height: 40px;
			line-height: 40px;
			border-radius: 3px;
			padding-left: 10px;

			.name {
				padding-left: 5px;
				border-left: 2px solid #F5882A;
			}
		}

		.footer {
			background-color: #fff;
			position: fixed;
			bottom: 0;
			height: 50px;
			line-height: 50px;
			display: flex;
			justify-content: space-between;
			left: 220px;
			right: 0;
			padding-left: 20px;
			z-index: 200;
		}
	}
</style>
